module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (5).69d56776.jpg";